export const SHIPPING_METHOD_CODE_QUERY_PARAM = 'shippingMethodCode';
export const FINISH_QUERY_PARAM = 'finish';
export const SHEEN_QUERY_PARAM = 'sheen';
export const WIREBRUSH_QUERY_PARAM = 'wirebrush';
export const ORDER_ID_QUERY_PARAM = 'orderId';
export const SAVED_CART_QUERY_PARAM = 'savedCart';
export const CART_LINE_ITEM_ID_QUERY_PARAM = 'cartLineItemId';
export const CART_CUSTOM_LINE_ITEM_ID_QUERY_PARAM = 'cartCustomLineItemId';
export const CART_ITEM_QUANTITY_QUERY_PARAM = 'cartItemQuantity';
export const CART_ITEM_FINISH_QUERY_PARAM = 'cartItemFinish';
